// Aviso discreto y no bloqueante de que hay una versión nueva de la app
// instalada y esperando (bug de producción: usuarios quedaban atrapados en
// una versión vieja del bundle sin ninguna forma de enterarse). Al tocar
// "Actualizar" se activa el Service Worker nuevo y se recarga la página.
import { useEffect } from "react";
import { toast } from "sonner";
import { onSWUpdate, applySWUpdate } from "@/serviceWorkerRegistration";

export function UpdateAvailableBanner() {
  useEffect(() => {
    onSWUpdate(() => {
      toast.custom(
        (t) => (
          <div
            data-testid="sw-update-banner"
            className="flex items-center gap-3 bg-card border border-border rounded-xl px-4 py-3 shadow-lg"
          >
            <span className="text-sm">Hay una versión nueva.</span>
            <button
              type="button"
              data-testid="sw-update-reload-button"
              className="text-sm font-semibold text-emerald-700 underline shrink-0"
              onClick={() => {
                applySWUpdate();
                toast.dismiss(t);
              }}
            >
              Tocá para actualizar
            </button>
          </div>
        ),
        { duration: Infinity }
      );
    });
  }, []);
  return null;
}
